import type { ResultOf } from '@graphql-typed-document-node/core';

import { mutation } from '../../common/requests/base.mutation.ts';
import { ResultType } from '../../main/types/result.types.ts';
import { getReadingCrittersClientUtil } from '../../main/utils/clients/readingcritters.client.util.ts';

const DELETE_PARENT_ACCOUNT_MUTATION = mutation({
  deleteParentAccount: {
    success: true,
  },
});

type DeleteParentAccountResponseType = ResultOf<typeof DELETE_PARENT_ACCOUNT_MUTATION>['deleteParentAccount'];

export const deleteParentAccountMutationRequest = async (): Promise<ResultType<DeleteParentAccountResponseType>> => {
  const client = getReadingCrittersClientUtil();

  try {
    const response = await client.mutation(DELETE_PARENT_ACCOUNT_MUTATION, {}, { useAuth: true });

    return {
      success: Boolean(response?.deleteParentAccount?.success),
      data: response?.deleteParentAccount ?? { success: false },
    };
  } catch (error) {
    return {
      success: false,
      message: (error as Error).message,
    };
  }
};
